import { render, staticRenderFns } from "./PatientBaseFieldSet.vue?vue&type=template&id=a6b7be9e&scoped=true"
import script from "./PatientBaseFieldSet.vue?vue&type=script&lang=js"
export * from "./PatientBaseFieldSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b7be9e",
  null
  
)

export default component.exports